import React, {useEffect} from 'react'
import '../App.css';
import './HeroSection.css';
import locomotiveScroll from 'locomotive-scroll';

function HeroSection() {
  const scrollRef = React.createRef();

  useEffect(() => {
      const scroll = new locomotiveScroll({
        el: scrollRef.current,
        smooth: true,
        smartphone: {
          smooth : true,
        },
        getDirection: true,
        getSpeed: true,
        smartphone: {
          smooth: false,
            breakpoint: 767
        },
        tablet: {
            smooth: !1,
            breakpoint: 1024
        },
        });
    });


  return (
    <div className='hero-container' data-scroll-container ref={scrollRef}>
        <h1  data-scroll-speed="1.3">FRS</h1>
        <h2 data-scroll data-scroll-speed="-1.3" id="hero_subtitle">Web Developer Portfolio</h2>
    </div>
  )
}

export default HeroSection